import {
  PagedResponseEmpty,
} from "@ofqual/portal-core/core/types";
import { combineReducers, AnyAction } from "redux";
import {
  ASSIGN_ITEM,
  CLOSED_ITEM,
  CLOSE_ITEM,
  LOADED_ITEM,
  LOADED_ITEMS,
  LOADING_ITEM,
  LOADING_ITEMS,
  REOPEN_ITEM,
  RESET_MULTIPLE_MESSAGE,
  SAVED_ITEM,
  SENDING_ITEM,
  SENT_ITEM,
  SENT_MULTIPLE_MESSAGE,
  UNASSIGN_ITEM,
  UPDATING_ITEM,
} from "./actions";
import {  ItemsState, ItemState } from "./state";
import {  noCrudResult, successCrudResult } from "./types";

const itemsInitialState: ItemsState = {
  status: "NOT_LOADED",
  response: PagedResponseEmpty,
  hasData: false,
  multiMessageNumber: undefined,
};

const items = (
  state: ItemsState = itemsInitialState,
  action: AnyAction
): ItemsState => {
  const { type, payload } = action;
  if (type === LOADING_ITEMS) {
    return {
      ...state,
      status: "LOADING",
    };
  }
  if (type === LOADED_ITEMS) {
    return {
      ...state,
      status: "LOADED",
      response: payload,
      hasData: true,
    };
  }
  if (type === SENT_MULTIPLE_MESSAGE) {
      return {
      ...state,
      status: "MESSAGES_SENT",
      multiMessageNumber: payload
    };
  }
  if (type === RESET_MULTIPLE_MESSAGE) {
      return {
      ...state,
      status: "LOADED",
      multiMessageNumber: undefined
    };
  }
  return state;
};

const itemInitialState: ItemState = {
  status: "NOT_LOADED",
  item: null,
  lastCrudResult: noCrudResult(),
};

const item = (
  state: ItemState = itemInitialState,
  action: AnyAction
): ItemState => {
  const { type, payload } = action;
  switch (type) {
    case LOADING_ITEM:
      return {
        ...state,
        item: null,
        status: "LOADING",
        lastCrudResult: noCrudResult(),
      };
    case UPDATING_ITEM:
    case ASSIGN_ITEM:
    case UNASSIGN_ITEM:
    case REOPEN_ITEM:
      return {
        ...state,
        status: "UPDATING",
        lastCrudResult: noCrudResult(),
      };
    case LOADED_ITEM:
      return {
        ...state,
        status: "LOADED",
        item: payload,
      };
    case SAVED_ITEM:
      return {
        ...state,
        status: "LOADED",
        item: payload,
        lastCrudResult: successCrudResult(),
      };
    case SENDING_ITEM:
      return {
        ...state,
        status: "UPDATING",
        lastCrudResult: noCrudResult(),
      };
    case SENT_ITEM:
      return {
        ...state,
        status: "LOADED",
        item: payload,
        lastCrudResult: successCrudResult(),
      };
    case CLOSE_ITEM:
      return {
        ...state,
        status: "UPDATING",
        lastCrudResult: noCrudResult(),
      };
    case CLOSED_ITEM:
      return {
        ...state,
        status: "LOADED",
        item: payload,
        lastCrudResult: successCrudResult(),
      };
    default:
      return state;
  }
};

export const rootReducer = combineReducers({
  items,
  item,
});
